import { format, intlFormatDistance, differenceInDays, differenceInSeconds, parseISO, intlFormat, formatISO } from 'date-fns';
import { findIana } from 'windows-iana';

export const BASE_DATE_FORMAT = 'yyyy-MM-dd'; // e.g., 2025-08-26
export const BASE_DATE_TIME_FORMAT = 'yyyy-MM-dd H:mm:ss'; //e.g., 2025-08-26 08:59:30
export const LONG_DATE_FORMAT = 'iii, MMM do, yyyy'; //e.g., Tue, Aug 26th, 2025
export const LONG_MONTH_DATE_FORMAT = 'MMMM d, yyyy'; // e.g., August 26, 2025
export const LONG_MONTH_DATE_AM_PM_TIME_FORMAT = 'MMMM d, yyyy h:mm aaa'; //e.g., August 26, 2025 8:59 am

export const getCurrentDate = (): string => format(new Date(), BASE_DATE_FORMAT);
export const getCurrentDateAndTime = (): string => format(new Date(), BASE_DATE_TIME_FORMAT);

export const formatRelativeDate = (dateString: string): string => {
  const earlierDate = parseISO(dateString);
  const now = new Date();
  if (differenceInSeconds(now, earlierDate) < 60) {
    return 'Just now';
  } else if (differenceInDays(now, earlierDate) <= 3) {
    const distance = intlFormatDistance(earlierDate, now, { style: 'short' });
    return distance;
  } else {
    return format(earlierDate, BASE_DATE_FORMAT);
  }
};

export const formatDate = (dateString: string, formatDate: string): string => {
  const date = parseISO(dateString);
  return format(date, formatDate);
};

export const convertDateToUserTimezone = (dateString: string, timeZone: string): string => {
  const utcDateString = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
  const date = parseISO(utcDateString);
  const foundIanaTimeZones = findIana(timeZone || 'Eastern Standard Time');
  const ianaTimeZone = foundIanaTimeZones[0];
  const options = {
    timeZone: ianaTimeZone,
    year: 'numeric' as const,
    month: 'numeric' as const,
    day: 'numeric' as const,
    hour: 'numeric' as const,
    minute: 'numeric' as const,
    second: 'numeric' as const,
    hour12: false,
  };
  const formattedDate = intlFormat(date, options);
  return formatISO(new Date(formattedDate), { representation: 'complete' });
};

export const formatRelativeDateInUserTimezone = (dateString: string, timeZone: string): string => {
  return formatRelativeDate(convertDateToUserTimezone(dateString, timeZone));
};

export const formatDateInUserTimezone = (dateString: string, timeZone: string, formatDateString: string): string => {
  return formatDate(convertDateToUserTimezone(dateString, timeZone), formatDateString);
};
